import Chip, { ChipProps } from "@mui/material/Chip";
import { useTranslation } from "react-i18next";

import { EmployeeStatus } from "../types/processTypes";

function statusChipColor(
  status: EmployeeStatus | undefined,
): ChipProps["color"] {
  if (!status) return "default";
  if (status === EmployeeStatus.pending) return "warning";
  if (
    status === EmployeeStatus.departed ||
    status === EmployeeStatus.contract_completed
  ) {
    return "success";
  }
  if (
    status === EmployeeStatus.discontinued ||
    status === EmployeeStatus.stopped ||
    status === EmployeeStatus.lost ||
    status === EmployeeStatus.returned ||
    status === EmployeeStatus.has_complain
  ) {
    return "error";
  }
  if (
    status === EmployeeStatus.flight_booked ||
    status === EmployeeStatus.ticketing ||
    status === EmployeeStatus.visa_issued ||
    status === EmployeeStatus.labour_issued
  ) {
    return "warning";
  }
  if (
    status === EmployeeStatus.selected ||
    status === EmployeeStatus.contracted
  ) {
    return "info";
  }
  return "default";
}

interface Props {
  status?: EmployeeStatus;
  size?: ChipProps["size"];
}

export function EmployeeStatusChip({ status, size = "small" }: Props) {
  const { t: te } = useTranslation("enums");
  const value = status ?? EmployeeStatus.new;
  const isDefault =
    value === EmployeeStatus.new || value === EmployeeStatus.pending;

  return (
    <Chip
      label={te(value)}
      color={statusChipColor(value)}
      variant={isDefault ? "outlined" : "filled"}
      size={size}
      sx={{ fontWeight: 600, fontSize: "0.7rem" }}
    />
  );
}
